/* eslint-disable */
<template>
  <section id="main-content">

    <nav class="
          mt-4
          ms-lg-4
          align-items-center
          justify-content-center
          d-flex
          justify-content-lg-start
        ">
      <h2 :class="'tabswitch' + (this.allReports ? ' ' : ' active')" @click="switchView">

        {{ language.includes('en') ? "Learning Categories" : "Catégories d'apprentissage" }}
      </h2>
      <h2 :class="'tabswitch' + (this.allReports ? ' active' : '')" @click="switchView">

        {{ language.includes('en') ? "All Courses & Webinars" : "Tous les cours et webinaires" }}
      </h2>
    </nav>

    <div class="container-fluid" id="currentRow" v-show="!allReports">
      <carousel-row :reports="reports.slice(0, 8)"
        :category="language.includes('en') ? 'Newest On-Demand Webinars &amp; Courses' : 'Nouveaux webinaires à la demande &amp; Cours'"
        abbr="newest" status="Current" learningRow="true" v-if="language.includes('en')" />

      <carousel-row :reports="categoryItems(4320).length > 0
          ? categoryItems(4320)[0].items.reverse()
          : []
        " :category="language.includes('en') ? 'Top Ranking Webinars' : 'Webinaires les mieux classés'"
        :categoryDescription="language.includes('en') ? 'Short presentations that are actionable and easy to fit into your schedule - most are 60 min or less!' : ''"
        abbr="webinars" status="Current" learningRow="true" v-if="language.includes('en')" />

      <carousel-row :reports="categoryItems(4321).length > 0
          ? categoryItems(4321)[0]
            .items

          : []
        " :category="language.includes('en') ? 'Popular Online Courses' : 'Cours en ligne populaires'"
        :categoryDescription="language.includes('en') ? 'Longer e-learning style content to help you hone skills for success, requires a time commitment of 2 to 20 hours.' : ''"
        abbr="popular_courses" status="Current" learningRow="true" v-if="language.includes('en')" />

      <!-- FRENCH ROWS -->

      <!-- NOT WEBINARS -->
      <carousel-row :reports="categoryItems(3847).length > 0
          ? categoryItems(3847)[0]
            .items.filter(item => {
              return !item['event-type'].includes('Webinar')

            })

          : []
        " category="Sélection rapide de formations" categoryDescription="" abbr="webinars" status="Current"
        learningRow="true" v-if="language.includes('fr')" />

      <!-- WEBINARS -->
      <carousel-row :reports="categoryItems(3847).length > 0
          ? categoryItems(3847)[0]
            .items.filter(item => {
              return item['event-type'].includes('Webinar')

            })

          : []
        " category="Les plus populaires" categoryDescription="" abbr="webinars" status="Current" learningRow="true"
        v-if="language.includes('fr')" />
    </div>

    <!-- SP: All reports grid -->
    <div class="container-fluid" id="allReportsRow" v-if="(reports.length > 0) & allReports" :firstid="reports[0].ID">
      <div class="row mx-0">
        <div class="col-xl-2 ms-auto col-lg-4 col pb-4 ps-4" v-if="language.includes('en')">
          <form :class="{
            'form-inline': true,

            'd-none': !showFilters,
            'd-lg-flex flex-column justify-content-start align-items-start': true,
          }" @submit.prevent>
            <label class="fw-bold my-2">
              {{ language.includes('en') ? "Filter by Course Category" : "Filtrer par catégorie de cours" }}
            </label>
            <div class="form-check ps-3 mb-1 text-muted" v-for="category in categories" :key="category.id"
              :id="'category_checkbox_wrap_' + category.id">
              <input class="form-check-input me-4" :id="'category_checkbox_' + category.id" type="checkbox"
                v-model="selectedCategories" :value="category" />
              <label class="form-check-label small" :for="'category_checkbox_' + category.id">
                {{ category.name }}
              </label>
            </div>
            <label class="fw-bold mb-2 mt-5">Filter by Career Level</label>
            <div class="form-check ps-3 mb-1 text-muted" v-for="careerLevel in careerStages" :key="careerLevel"
              :id="'category_checkbox_wrap_' + careerLevel">
              <input class="form-check-input me-4" :id="'category_checkbox_' + careerLevel" type="checkbox"
                v-model="selectedCareerStages" :value="careerLevel" />
              <label class="form-check-label small" :for="'category_checkbox_' + careerLevel">
                {{ careerLevel }}
              </label>
            </div>
          </form>
        </div>
        <div :class="(language.includes('en') ? 'col-xl-10 col-lg-8' : 'col') + 'col'">
          <grid-container :allReports="reports" category="All Reports" :selectedCategories="selectedCategories"
            :selectedCareerStages="selectedCareerStages" abbr="all" status="Current" gridTitle="Browse Online Learning"
            :learningGrid="true" :language="language" @toggleFilters="
              showFilters ? (showFilters = false) : (showFilters = true)
              " />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import "bootstrap";

import '../assets/_globals.scss';
import '../assets/style.scss';
import CarouselRow from './CarouselRow';
import GridContainer from './GridContainer.vue'
export default {
  name: "IndexPage",
  components: {
    CarouselRow,
    GridContainer
  },
  data() {
    return {
      reports: [],
      categories: [],
      selectedCategories: [],
      careerStages: [],
      selectedCareerStages: [],
      loading: false,
      allReports: false,
      showFilters: false,
    };
  },
  methods: {
    switchView() {
      this.allReports = !this.allReports;
    },
    getCookie(name) {
      var dc, prefix, begin, end;

      dc = document.cookie;
      prefix = name + "=";
      begin = dc.indexOf("; " + prefix);
      end = dc.length; // default to end of the string

      if (begin !== -1) {
        begin += 2;
      } else {
        begin = dc.indexOf(prefix);
        if (begin === -1 || begin !== 0) return null;
      }

      if (dc.indexOf(";", begin) !== -1) {
        end = dc.indexOf(";", begin);
      }

      return decodeURI(dc.substring(begin + prefix.length, end)).replace(
        /\"/g,
        ""
      );
    },
    categoryItems(categoryId) {
      var a = JSON.parse(
        JSON.stringify(this.categories.filter((item) => item.id == categoryId))
      );
      if (a) {
        // console.log("found:", a[0], this.categories);
        return a;
      } else {
        return [];
      }
    },
  },
  computed: {
    language() {
      return this.getCookie("pll_language") ? this.getCookie("pll_language") : "en";
    },
  },
  mounted() {
    let vm = this;
    vm.loading = true;
    fetch("https://eco.ca/wp-json/wp/v2/online-learning-category?per_page=100")
      .then((response) => response.json())
      .then((data) => {
        for (let i = 0; i < data.length; i++) {
          var cat = {
            id: data[i].id,
            name: data[i].name,
            items: [],
          };
          //if(cat.id !== 3847){

          vm.categories.push(cat);
          vm.selectedCategories = [...vm.selectedCategories, cat];
          //}
        }

        console.log(vm.categories);
        fetch(
          "https://eco.ca/wp-content/themes/hello-theme-child-master/learning_api.php"
        )
          .then((response) => response.json())
          .then((data) => {
            vm.reports = Object.values(data);

            vm.reports.reverse();

            for (var report in vm.reports) {
              for (var cat in vm.categories) {
                if (
                  vm.reports[report].post_category_id.includes(
                    vm.categories[cat].id
                  )
                ) {
                  vm.categories[cat].items.push(vm.reports[report]);
                }
              }
              if (
                vm.careerStages.indexOf(
                  vm.reports[report]["career-stage-friendly"]
                ) == -1
              ) {
                vm.careerStages.push(
                  vm.reports[report]["career-stage-friendly"]
                );
                vm.selectedCareerStages.push(
                  vm.reports[report]["career-stage-friendly"]
                );
              }
            }
            console.log("fetched: ", vm.reports, vm.categories);
            vm.loading = false;
          })
          .catch((err) => {
            console.error(err);
            vm.loading = false;
          });
      });
  },
};
</script>

<style scoped>
/* need to exclude these from filtering... */
/* hide Top Ranking Webinars, Top Ranking Courses, and Employability & Career Advice */
#category_checkbox_wrap_4320,
#category_checkbox_wrap_4321,
#category_checkbox_wrap_3846 {
  display: none;
}
</style>